export const breakpoint = (val) => (`min-width: ${ val }`)
